import {
  CNP_EVENT,
  ENV,
  INTEGRATION_TYPE,
  OPTIONAL_CNP_EVENT,
  OPTIONAL_TERMINAL_EVENT,
  PAYMENT_STATUS,
  PLATFORM_TYPE,
  PROCESSOR,
  TERMINAL_EVENT,
  TerminalEventMonitoring as LspayTerminalMonitoring,
} from '@lightspeed-payments/payments-terminal-sdk';
import { Product } from '@lightspeed-payments/utils';

export type { LspayTerminalMonitoring };
export {
  CNP_EVENT,
  ENV,
  INTEGRATION_TYPE,
  OPTIONAL_CNP_EVENT,
  OPTIONAL_TERMINAL_EVENT,
  PAYMENT_STATUS,
  TERMINAL_EVENT,
};

export function getEnv(): (typeof ENV)[keyof typeof ENV] {
  const { hostname } = window.location;
  if (/lightspeedapp(?:staging|stg)/.test(hostname)) return ENV.STAGE;
  if (/merchantos|lightspeedapp/.test(hostname)) return ENV.PROD;
  return ENV.TRIAL;
}

export function initLspayMonitoring(
  pli: string,
  integrationType: (typeof INTEGRATION_TYPE)[keyof typeof INTEGRATION_TYPE]
): LspayTerminalMonitoring {
  const env = getEnv();
  return LspayTerminalMonitoring.init({
    clientToken: 'pub9dc1c44452c2a54cbc2fe1068a9b06ee',
    service: 'r-series-pos',
    env,
    product: Product.rSeries,
    pli,
    processor: PROCESSOR.STRIPE,
    platformType: PLATFORM_TYPE.WEB,
    integrationType,
    verbose: env !== ENV.PROD,
  });
}
